import alert from './alert'
import avatar from './avatar'
import backdrop from './backdrop'
import badge from './badge'
import breadcrumbs from './breadcrumbs'
import button from './button'
import chip from './chip'
import circularProgress from './circularProgress'
import dialog from './dialog'
import divider from './divider'
import form from './form'
import iconButton from './iconButton'
import link from './link'
import list from './list'
import menu from './menu'
import pagination from './pagination'
import pickerDay from './pickerDay'
import popover from './popover'
import snackbar from './snackbar'
import stepper from './stepper'
import switchInput from './switchInput'
import table from './table'
import tabs from './tabs'
import timeline from './timeline'
import tooltip from './tooltip'
import typography from './typography'

import { mergeDeep } from '../utils'

export default mergeDeep(
  alert,
  avatar,
  backdrop,
  badge,
  breadcrumbs,
  button,
  chip,
  circularProgress,
  dialog,
  divider,
  form,
  iconButton,
  link,
  list,
  menu,
  pagination,
  pickerDay,
  popover,
  snackbar,
  stepper,
  switchInput,
  table,
  tabs,
  timeline,
  tooltip,
  typography,
)
